import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'
import {loadLayoutMiddleware} from "@/router/middleware/loadLayoutMiddleware"

import { useUserStore } from '../store/user';
import { usePlaybackStore } from '@/store/playbackStore';
import DashboardPage from '../views/DashboardPage.vue'
// import BrowsePage from '../views/BrowsePage.vue'
import ApplicationPage from '../views/ApplicationPage.vue'
import DocumentPage from '../views/DocumentPage.vue'
import DoocumentDetailed from '../views/DoocumentDetailed.vue'
import WorkspacePage from '../views/WorkspacePage.vue'
import PlaylistCreate from '../views/PlaylistCreate.vue'
import PlaylistDetails from '../views/PlaylistDetails.vue'
import PlaylistPage from '../views/PlaylistPage.vue'
import PlaylistPlay from '../views/PlaylistPlay.vue'
import PodcastPage from '../views/PodcastPage.vue'
import PodcastDetails from '../views/PodcastDetails.vue'
import TextbookPage from '../views/TextbookPage.vue'
import FeedbackPage from '../views/FeedbackPage.vue'
import SettingPage from '../views/SettingPage.vue'
// import LoginPage from '../views/LoginPage.vue'
import NewLoginPage from '../views/NewLoginPage.vue'
import TeachersPage from '../views/TeachersPage.vue'
import TeacherDetailPage from '../views/TeacherDetailPage.vue'
import AllSearchResultPage from '../views/AllSearchResultPage.vue'
import ErrorPage from '../views/ErrorPage.vue'
import LoginPage from "@/views/LoginPage.vue";
import WelcomePage from '@/views/WelcomePage.vue';
import PrivacyPage from '@/views/PrivacyPage.vue';
import TermPage from '@/views/TermPage.vue';
import PreschoolDocumentPage from '@/views/PreschoolDocumentPage.vue';
import PrimarySchoolDocumentPage from '@/views/PrimarySchoolDocumentPage.vue';
import SecondarySchoolDocumentPage from '@/views/SecondarySchoolDocumentPage.vue';
import SpecialEducationDocumentPage from '@/views/SpecialEducationDocumentPage.vue';
import LiteracyPage from '@/views/LiteracyPage.vue';
import NumeracyPage from '@/views/NumeracyPage.vue';
import VocationalCollegePage from '@/views/VocationalCollegePage.vue';
import Form6Page from '@/views/Form6Page.vue';
import UnauthorizedPage from '@/views/UnauthorizedPage.vue';
import HelpCenterPage from '@/views/HelpCenterPage.vue';
import HelpArticlePage from '@/views/HelpArticlePage.vue';
import GalleryPage from '@/views/GalleryPage.vue';

const routes = [
    {
        path: '/',
        name: 'Welcome Page',
        component: WelcomePage,
        meta: {
            guest: true,
            layout: 'GuestLayout'
        }
    },
    {
        path: '/privacy',
        name: 'Privacy Page',
        component: PrivacyPage,
        meta: {
            guest: true,
            layout: 'GuestLayout'
        }
    },
    {
        path: '/terms',
        name: 'Term Page',
        component: TermPage,
        meta: {
            guest: true,
            layout: 'GuestLayout'
        }
    },
    {
        path: '/gallery',
        name: 'Gallery Page',
        component: GalleryPage,
        meta: {
            guest: true,
            layout: 'GuestLayout'
        }
    },
    {
        path: '/login',
        name: 'Login Page',
        component: NewLoginPage,
        meta: {
            guest: true,
            layout: 'GuestLayout'
        }
    },
    {
        path: '/dev-login',
        name: 'Dev Login Page',
        component: LoginPage,
        meta :{
            guest: true,
            layout: 'GuestLayout'
        }
    },
    {
        path: '/unauthorized',
        name: 'Unauthorized Page',
        component: UnauthorizedPage,
        meta :{
            guest: true,
            layout: 'GuestLayout'
        }
    },
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '/dashboard',
        name: 'Dashboard Page',
        component: DashboardPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    // {
    //     path: '/browse',
    //     name: 'Browse Page',
    //     component: BrowsePage,
    //     meta: { 
    //         requiresAuth: true,
    //         layout: 'DefaultLayout'
    //     },
    // },
    {
        path: '/application',
        name: 'Application Page',
        component: ApplicationPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/preschool',
        name: 'Preschool Document Page',
        component: PreschoolDocumentPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/primary-school',
        name: 'Primary School Document Page',
        component: PrimarySchoolDocumentPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/secondary-school',
        name: 'Secondary School Document Page',
        component: SecondarySchoolDocumentPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/special-education',
        name: 'Special Education Document Page',
        component: SpecialEducationDocumentPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/literacy',
        name: 'Literacy Page',
        component: LiteracyPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/numeracy',
        name: 'Numeracy Page',
        component: NumeracyPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/tingkatan-6',
        name: 'Form 6 Page',
        component: Form6Page,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/kolej-vokasional',
        name: 'Vocational College Page',
        component: VocationalCollegePage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/document',
        name: 'Document Page',
        component: DocumentPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/workspace',
        name: 'Workspace Page',
        component: WorkspacePage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/playlist',
        name: 'Playlist Page',
        component: PlaylistPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
         },
    },
    {
        path: '/playlist/detail',
        name: 'Playlist Detail',
        component: PlaylistDetails,
        props: route => ({
            id: route.query.id,
            isTeacherPlaylist: route.query.isTeacherPlaylist
        }),
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/playlist/create',
        name: 'Create Playlist',
        component: PlaylistCreate,
        props: route => ({
            id: route.query.id,
        }),
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/playlist/play/:id',
        name: 'Play Playlist',
        component: PlaylistPlay,
        props: route => ({
            id: route.params.id,
            isTeacherPlaylist: route.query.isTeacherPlaylist,
            assetBroadcastId: route.query.assetBroadcastId
        }),
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/documents/:id',
        name: 'DocumentDetailed',
        component: DoocumentDetailed,
        props: route => ({
            id: route.params.id
        }),
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/podcast',
        name: 'Podcast Page',
        component: PodcastPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/podcast/:id',
        name: 'Podcast Details',
        component: PodcastDetails,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/textbook',
        name: 'Textbook Page',
        component: TextbookPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/feedback',
        name: 'Feedback Page',
        component: FeedbackPage,
        meta: { 
            requiresAuth: true,           
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/setting',
        name: 'Setting Page',
        component: SettingPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/teachers',
        name: 'Teachers Page',
        component: TeachersPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/teachers/:id',
        name: 'Teacher Detail',
        component: TeacherDetailPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/search',
        name: 'All Search Result Page',
        component: AllSearchResultPage,
        meta: { 
            requiresAuth: true,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/error',
        name: 'ErrorPage',
        component: ErrorPage,
        props: route => ({
          errorTitle: route.query.title,
          errorMessage: route.query.message
        }),
        meta: { 
            requiresAuth: false,
            layout: 'DefaultLayout'
        },
    },
    {
        path: '/:catchAll(.*)',
        redirect: '/error',
    },
    {
        path: '/help',
        name: 'HelpCenter',
        component: HelpCenterPage,
        meta :{
            layout: 'GuestLayout',
        }
    },
    {
        path: '/help/article/:id',
        name: 'HelpArticle',
        component: HelpArticlePage,
        meta :{
            layout: 'GuestLayout',
        }
    }
      
]

const router = createRouter({
    history: createWebHistory('/'),
    routes,
    scrollBehavior() {
      return { top: 0 };
    },
  });
  
  // Navigation guard to check for authentication
  router.beforeEach(async (to, from, next) => {
        await loadLayoutMiddleware(to);
        
    const userStore = useUserStore();
    const playbackStore = usePlaybackStore();

        const isAuthenticated = userStore.isLoggedIn;

        // on login, show chatwoot
        if (from.name === 'Login Page' && to.name !== 'Login Page') { // show when login
            if (typeof window.$chatwoot !== 'undefined') {
                window.$chatwoot.toggleBubbleVisibility("show");
            }
        }

        if (to.name == 'Login Page' && from.name !== 'Login Page') { // hiden when logout
            if (typeof window.$chatwoot !== 'undefined') {
                window.$chatwoot.toggleBubbleVisibility("hide");
            }
        }

        if (from === START_LOCATION) {
            playbackStore.updatePlayingState(false);
        }

        // if navigate away from a Document Detailed or Playlist Play, stop the video
        if (from.name === 'DocumentDetailed' || from.name === 'Play Playlist') {
            playbackStore.updatePlayingState(false);
        }
    
        if (to.matched.some((record) => record.meta.requiresAuth) && !isAuthenticated) {
        next({ path: '/login' });
        } else if (to.matched.some((record) => record.meta.guest) && isAuthenticated) {
        next({ path: '/dashboard' });
        } else {
        next();
        }
    });

  export default router;